module.exports = __webpack_public_path__ + "VOLVO-logo.png";